import * as Types from '../../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchCustomersForCustomerSearchQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String']['input'];
}>;


export type SearchCustomersForCustomerSearchQuery = { __typename?: 'Query', searchCustomersBySearchTerm: { __typename?: 'SearchCustomersResponse', customers: Array<{ __typename?: 'SearchCustomerObject', createdAt: any, id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, secondaryPhoneNumber?: string | null, companyName?: string | null, linkedCustomers?: Array<{ __typename?: 'SearchCustomerObject', id: string, createdAt: any, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, secondaryPhoneNumber?: string | null, companyName?: string | null }> | null }> } };


export const SearchCustomersForCustomerSearchDocument = gql`
    query SearchCustomersForCustomerSearch($searchTerm: String!) {
  searchCustomersBySearchTerm(searchTerm: $searchTerm) {
    customers {
      createdAt
      id
      firstName
      lastName
      email
      phoneNumber
      secondaryPhoneNumber
      companyName
      linkedCustomers {
        id
        createdAt
        firstName
        lastName
        email
        phoneNumber
        secondaryPhoneNumber
        companyName
      }
    }
  }
}
    `;

/**
 * __useSearchCustomersForCustomerSearchQuery__
 *
 * To run a query within a React component, call `useSearchCustomersForCustomerSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomersForCustomerSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomersForCustomerSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchCustomersForCustomerSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchCustomersForCustomerSearchQuery, SearchCustomersForCustomerSearchQueryVariables> & ({ variables: SearchCustomersForCustomerSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomersForCustomerSearchQuery, SearchCustomersForCustomerSearchQueryVariables>(SearchCustomersForCustomerSearchDocument, options);
      }
export function useSearchCustomersForCustomerSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomersForCustomerSearchQuery, SearchCustomersForCustomerSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomersForCustomerSearchQuery, SearchCustomersForCustomerSearchQueryVariables>(SearchCustomersForCustomerSearchDocument, options);
        }
export function useSearchCustomersForCustomerSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCustomersForCustomerSearchQuery, SearchCustomersForCustomerSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCustomersForCustomerSearchQuery, SearchCustomersForCustomerSearchQueryVariables>(SearchCustomersForCustomerSearchDocument, options);
        }
export type SearchCustomersForCustomerSearchQueryHookResult = ReturnType<typeof useSearchCustomersForCustomerSearchQuery>;
export type SearchCustomersForCustomerSearchLazyQueryHookResult = ReturnType<typeof useSearchCustomersForCustomerSearchLazyQuery>;
export type SearchCustomersForCustomerSearchSuspenseQueryHookResult = ReturnType<typeof useSearchCustomersForCustomerSearchSuspenseQuery>;
export type SearchCustomersForCustomerSearchQueryResult = Apollo.QueryResult<SearchCustomersForCustomerSearchQuery, SearchCustomersForCustomerSearchQueryVariables>;